export enum StatementPoints {
  POST_ALLOWED = 'profile/application/allowed',
  POST_CREATE = 'profile/application/create',
}



// WEBPACK FOOTER //
// ./src/services/statement/types.ts